import type { ReactElement } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "./cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-neutral-600 bg-neutral-600/10 text-neutral-300",
        secondary: "border-blue-600 bg-blue-600/10 text-blue-600",
        destructive: "border-red-600 bg-red-600/10 text-red-600",
        outline: "border-neutral-600 bg-neutral-600/10 text-neutral-300",
        draft: "border-yellow-400 bg-yellow-400/10 text-yellow-400",
        pending: "border-orange-500 bg-orange-500/10 text-orange-400",
        approved: "border-green-500 bg-green-500/10 text-green-400",
        rejected: "border-red-600 bg-red-600/10 text-red-400",
        published: "border-blue-500 bg-blue-500/10 text-blue-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps): ReactElement {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
